import React, { useEffect, useState, useCallback } from "react";
import { Alert } from "react-bootstrap";
import LoadingSpinner from "./Visuals";
import getUrl from "../tools/get-domain";

export function CommentList(props) {
    const [comments, setComments] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [refresh, setRefresh] = useState(false)

    // async function fetchData() {
    const fetchDataCallback = useCallback(async function fetchData() {
        const url = getUrl().REACT_APP_COMMENT.replace(/{content_type_id}/g, props.content_type_id).replace(/{related_object_id}/g, props.related_object_id)
        try {
            const response = await fetch(
                url, {
                credentials: 'include',
            }
            )
            if (response.ok) {
                const result = await response.json();
                setComments(result)
                setError(false)
                setLoading(false)
            } else {
                setError(true)
            }
        } catch (e) {
            setError(true)
        }
    }, [props.content_type_id, props.related_object_id])
    // }
    useEffect(() => {
        fetchDataCallback()
    }, [fetchDataCallback]);
    // useEffect(() => {
    //     fetchData()
    // }, [refresh])

    return (
        <>
            {
                error
                    ?
                    (
                        <div dir="rtl" className="d-flex justify-content-center">
                            <Alert variant="warning" className="justify-content-center">
                                <Alert.Heading>خطای ارتباط با سرور</Alert.Heading>
                                <button className="btn btn-sm btn-warning" onClick={() => {
                                    setError(false)
                                    setLoading(true)
                                    setRefresh(!refresh)
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#0c0000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path
                                            d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                                    </svg>
                                </button>
                            </Alert>
                        </div>
                    )
                    :
                    loading
                        ?
                        <LoadingSpinner />
                        :
                        (comments.length > 0 ? comments.map((comment) => {
                            return <div key={comment.id}
                                className="question-item box-shadow position-relative">

                                <div className="row">
                                    <div className="col-12">
                                        <div>{comment.body}</div>
                                    </div>
                                </div>
                                {
                                    comment['comment_set'].map(
                                        (reply) =>
                                            <div key={reply.id} className="card-body "
                                            >
                                                <div className="row">
                                                    <div className="col-12 position-relative">
                                                        <div
                                                            className="symbol symbol-50px symbol-circle top-0 start-0 position-absolute">
                                                        </div>
                                                        <div className=" border-16 "
                                                            style={{
                                                                backgroundColor: '#F5F8FA',
                                                                borderColor: '#F5F8FA',
                                                                color: '#5E6278',
                                                            }}>{reply.body}</div>
                                                    </div>
                                                </div>
                                            </div>
                                    )
                                }

                            </div>
                        }) : <h1>موردی برای نمایش وجود ندارد</h1>)
            }
        </>
    )
}